import { type GridColDef } from "@mui/x-data-grid";

import { CctlTableEntry } from "api/public/cctlDirectory/cctlDirectory.types";
import AddressCell from "components/MUI/DataGrid/Cells/Address.cell";
import EmailCell from "components/MUI/DataGrid/Cells/Email.cell";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";

export const cctlTableColumns: GridColDef<CctlTableEntry>[] = [
  {
    headerName: "ID",
    field: "cctl_id",
    flex: 0.5,
  },
  {
    headerName: "Name",
    field: "cctl_name",
    flex: 1.5,
    renderCell: ({ row }) => (
      <LinkCell to={row.cctl_url} label={row.cctl_name} external />
    ),
  },
  {
    headerName: "Address",
    field: "address_1",
    flex: 2,
    renderCell: ({ row }) => (
      <AddressCell
        address1={row.address_1}
        address2={row.address_2}
        city={row.city}
        state={row.state_id?.us_state_abbrv}
        zip={row.zip}
      />
    ),
  },
  {
    headerName: "Test Methods",
    field: "lab_test_methods",
    flex: 1,
  },
  {
    headerName: "POC",
    field: "poc",
    flex: 1,
  },
  {
    headerName: "Phone",
    field: "work_phone",
    flex: 1,
  },
  {
    headerName: "Email",
    field: "poc_email",
    flex: 1,
    renderCell: ({ row }) => <EmailCell email={row.poc_email} />,
  },
  {
    headerName: "NVLAP Lab Code",
    field: "nvlap_lab_code",
    flex: 1,
  },
];
